module.exports = __webpack_public_path__ + "static/pic13.3f7600f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic13.jpg
// module id = 520
// module chunks = 263791100135453